import { call, select } from 'redux-saga/effects';

import { ensureSetFdDocument } from '@/domain/documents/sagas/sagas.navigation';

import { navigationDecisionInputSelector } from '@/domain/approvals/navigation/selectors';
import type { NavigationDecisionContext } from '@/domain/approvals/navigation/selectors';

// Refreshes the document navigation list (via ensureSetFdDocument →
// getNavigation, which dispatches updateNavigationAction with fresh
// listLength) and returns the up-to-date decision input.
//
// Why this exists: documentUpdate.success after approve/reject/publish only
// mutates the doc in-place; it does not shrink documentsByID. A direct
// select(navigationDecisionInputSelector) would read a stale listLength and
// `decideNavigation` would mis-route the post-action (e.g. miss the
// last-doc → "Well Done" fallback).
//
// Cost: one selector pass + zero or one backend refetch (the latter only
// when the user is at end-of-list, which is the same call they'd trigger
// manually on the next click — we just preempt it).
export function* getNavigationDecisionInput(): Generator<unknown, NavigationDecisionContext, unknown> {
  yield call(ensureSetFdDocument);
  return (yield select(navigationDecisionInputSelector)) as NavigationDecisionContext;
}
